exports.api = {
    register: `register`,
    categoryList: `category/list`,
    stateList: `state/list`,
    cityList: `cities/list`,
    registerSendOtp: `send-otp`,
    otpVerify: `verify-otp`,
    notification: `notification/list`,
    unseenNotification: `notification/unseen-count`,
    clearNotification: `notification/clear`,
    seenNotification: `notification/seen/`,
    dashboard: `provider/home`,
    userChatList: `provider/chat/user-list`,
    userBookingList: `provider/booking/list`,
    userProfileDetail: `user/detail/`,
    newsletterSubscribe: `newsletter/subscribe`,
    newsletterUnsubscribe: `newsletter/un-subscribe`,
    addNewsletter: `newsletter/add`,
    planList: `admin/plan`,
    subscriptionPayment: `plan/subscribe`,
    changeSubscription: `plan/change`,
    profile: `user/profile`,
    updateProfile: `provider/update/`,
    updateProfileImage: `user/profile-image`,
    deleteAccount: `delete`,
    advertisement: `advertisement/list`,
    deleteAdvertisement: `advertisement/delete/`,
    updateAdvertisement: `advertisement/update/`,
    addAdvertisement: `advertisement/add`,
    paymentAdvertisement: `payment/post-ads`,
    postedAdvertisement: `advertisement/my-posted-ads`,
    advertisementDetail: `advertisement/details/`,
    advertisementChangeStatus: `admin/advertisement/status/`,
    tagsList: `tag/list`,
    myJobs: `provider/request/myjob`,
    lockedJobs: `provider/job/requested-list`,
    jobDetails: `admin/care/job-detail/`,
    paymentUnlockRequest: `payment/unlock-request`,
    careNetwork: `provider/requested/applied-applicant`,
    careNetworkDetail: `provider/posted/job/detail/`,
    postedJob: `provider/posted/job-list`,
    addPost: `job/post`,
    planLimit: `provider/plan/limit`,
    addPostPayment: `payment/job-post`,
    deletePost: `job/post/`,
    networkDirectory: `provider/List`,
    userDetail: `provider/detail/`,
    subscriptionAuth: `plan/subscribed`,
    subscriptionCancel: `plan/cancel`,
    transactionList: `transaction/history`,
    calendarData: `provider/calenders`,
    providerDealStatus: `provider/deal/status/`,
    matchedApplicant: `provider/job/profile/matched-applicant`,
    sendContactUs: `contactus`,
    contactUsDetail: `contactus`,
    chatImage: `chat/image`,
    reviewList: `reviews/list`,

    expenseDashboard: `expense/dashboard`,
    expenseListing: `expense/list`,
    addBudget: `budget/add`,
    expenseDelete: `expense/delete/`,
    addExpense: `expense/add`,
    editExpense: `expense/update/`,
    detailsExpense: `expense/detail/`,
    categoryListing: `expense/category/list`,
    addCategory: `expense/category/add`,
    cardListing: `expense/card`,
    addCard: `expense/card`,
    budgetList: `budget/list`,
    budgetDelete: `budget/delete/`,
    budgetUpdate: `budget/update/`,

    communityDashboard: `community/dashboard`,
    communitySuggested: `community/list`,
    communityFollow: `community/follow/`,
    communityUnFollow: `community/unfollow/`,
    communityFollowing: `community/my-following`,
    communityList: `community/my-created`,
    communityAdd: `community/add`,
    communityUpdate: `community/update/`,
    communityDelete: `community/delete/`,
    communityDetail: `community/details/`,
    postAdd: `community/post`,
    postUpdate: `community/post/update/`,
    pollAnswer: `community/poll/user/response`,
    postReaction: `post/reaction`,
    communityPostDetail: `community/post/detail/`,
    postComment: `post/comment/add`,
    communityPostDelete: `community/post/delete/`,
    communityCommentDelete: `post/comment/delete/`,
    commentUpdate: `post/comment/update/`,
    commentReaction: `post/comment/reaction`,
    shareProfile: `community/shared/profile`,
    shareCommunityList: `user/community/list`,

    loyaltyCouponList: `coupon/list`,
    couponValidity: `plan/coupon-validity`,
    applyCoupon: `coupon/apply-coupon`,
    leadCouponApply: `loyalty/coupon/apply`,
    leadCouponList: `loyalty/coupon/list`,
    cancelCoupon: `loyalty/coupon/cancel`,
    postCouponApply: `loyalty/post/coupon/apply`,
    adsCouponApply: `loyalty/ads/coupon/apply`,
}